import { Box, Typography } from "@mui/material";
import { getIncomeTaxNewUpdates } from "api/services/automation/income-tax-tan";
import Table from "components/Table";
import useTitle from "hooks/useTitle";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";

const TanNewUpdates = () => {
  useTitle("ATOM Pro | Updates");
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  const { data, isLoading }: ResType = useQuery(
    ["Income-tax-tan-new-updates"],
    getIncomeTaxNewUpdates,
    {
      // enabled:
      //   permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
      //   permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );
  const handleClick = (row) => {
    navigate(`/atom-pro/income-tax-tan/new-updates/${row?.id}`);
  };
  const columns = [
    {
      key: "client.clientId",
      title: "Client ID",
    },
    {
      key: "client.displayName",
      title: "Client",
    },
    {
      key: "id",
      title: "e-Challan",
      render: (row: any) => <Typography>New : {row?.eChallan?.newItem?.length}</Typography>,
    },
    {
      key: "id",
      title: "AR (CA)",
      render: (row: any) => <Typography>New : {row?.myCas?.newItem?.length}</Typography>,
    },
    {
      key: "id",
      title: "Forms",
      render: (row: any) => <Typography>New : {row?.forms?.newItem?.length}</Typography>,
    },
    {
      key: "id",
      title: "Traces Inbox",
      render: (row: any) => (
        <Typography>New : {row?.traceCommunication?.newItem?.length}</Typography>
      ),
    },
    {
      key: "id",
      title: "e-Proceeding(FYA) Excel",
      render: (row: any) => <Typography>New : {row?.tempNoticeFya?.newItem?.length}</Typography>,
    },
    {
      key: "id",
      title: "e-Proceeding(FYI) Excel",
      render: (row: any) => <Typography>New : {row?.tempNoticeFyi?.newItem?.length}</Typography>,
    },
    {
      key: "id",
      title: "Traces Outstanding Demand",
      render: (row: any) => <Typography>New : {row?.outstandingDemand?.newItem?.length}</Typography>,
    },
  ];
  // if (
  //   !(
  //     permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //     permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   )
  // ) {
  //   return <AccessDenied />;
  // }

  return (
    <Box sx={{ padding: 2 }} overflow="auto" height={"600px"}>
      <Table
        sx={{ height: "75vh" }}
        data={data?.data || []}
        columns={columns}
        loading={isLoading}
        onRowClick={handleClick}
      />
    </Box>
  );
};

export default TanNewUpdates;
